

















































import { message } from 'ant-design-vue'
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { BUSSINESS, BUSSINESS_SUBJECTS } from '../../../service/constant'
import { contentUpload } from '../../../service/platform'

const clone = (obj) => JSON.parse(JSON.stringify(obj))

@Component
export default class ContentUpload extends Vue {
  private get bizs() {
    return (this.$store.state[BUSSINESS] || []).filter((item) => [4001, 5001].includes(item.value))
  }
  private get subjects() {
    if (!this.submitData.business_type) return []
    const dict = this.$store.state[BUSSINESS_SUBJECTS]
    return dict[this.submitData.business_type] || []
  }
  private submitData = {
    business_type: 4001,
    subject_id: 103,
    resource_urls: ['']
  }

  @Watch('submitData.business_type')
  public onBussinessChange(val) {
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.submitData.subject_id)) {
      setTimeout(() => {
        this.submitData.subject_id = this.subjects[0].value
      })
    }
  }

  public submit() {
    let data = clone(this.submitData)
    data.resource_urls = data.resource_urls.map((item) => (item || '').trim())
    contentUpload(data).then((retData) => {
      if (retData.success) {
        this.submitData.resource_urls = ['']
        this.$message.success('上传成功')
      }
    })
  }

  private addItem() {
    this.submitData.resource_urls.push('')
  }
  private remove(index) {
    this.submitData.resource_urls.splice(index, 1)
  }
  private onChange(index, value) {
    this.submitData.resource_urls.splice(index, 1, value)
  }
}
